export default "__VITE_ASSET__CXqsxNWR__"